import { differenceInDays } from "date-fns";

// export const calculateDaysAgo = (dateString) => {
//   const today = new Date();
//   const [day, month, year] = dateString.split("/").map(Number);
//   const targetDate = new Date(year, month - 1, day); // Month is 0-based
//   return differenceInDays(today, targetDate);
// };

export const calculateDaysAgo = (dateString) => {
  const dateMDY = new Date(dateString).toLocaleDateString("en-GB");
  // Extract day, month, and year manually
  const [day, month, year] = dateMDY.split("/").map(Number);

  // Create Date object
  const givenDate = new Date(year, month - 1, day);
  const today = new Date();

  // Calculate time difference in milliseconds
  const diffTime = today - givenDate;

  // Convert to days, months, and years
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  // Return formatted string
  if (diffYears > 0) return diffYears === 1 ? "1 year" : `${diffYears} years`;
  if (diffMonths > 0) return diffMonths === 1 ? "1 month" : `${diffMonths} months`;
  return diffDays === 1 ? "1 day" : `${diffDays} days`;
};

const formatToIndianUnits = (amount) => {
  if (Math.abs(amount) >= 10000000) {
    return (amount / 10000000).toFixed(1).replace(/\.0$/, "") + "C"; // Crore
  } else if (Math.abs(amount) >= 100000) {
    return (amount / 100000).toFixed(1).replace(/\.0$/, "") + "L"; // Lakh
  } else if (Math.abs(amount) >= 1000) {
    return (amount / 1000).toFixed(1).replace(/\.0$/, "") + "K"; // Thousand
  }
  return amount.toLocaleString("en-IN"); // Default Indian numbering format
};

export const IndianCurrencyDisplay = ({ amount, isPositive }) => {
  return <span
    style={{
      color: isPositive ? "#2C3659" : "#ff0000"
    }}
  >{formatToIndianUnits(amount)}</span>;
};

export const compareSale = (data, target) => {
  const salePrevious = data[0]?.[target] || 0
  const saleCurrent = data[1]?.[target] || 0
  console.log("COM55", data, salePrevious, saleCurrent);

  if (salePrevious === 0) return "No previous sales data"; // Avoid division by zero

  const percentage = ((saleCurrent - salePrevious) / salePrevious) * 100;
  const retVal = {
    value: Math.abs(percentage).toFixed(0),
    increase: percentage > 0
  }
  return retVal
}

export const calculateProfitAmount = (data) => {
  const totalSales = data[0]?.totalSales || 0
  const totalExpenses = data[0]?.totalExpense || 0
  const difference = totalSales - totalExpenses
  const retVal = {
    value: Math.abs(difference).toFixed(0),
    increase: difference > 0
  }
  return retVal
}

export const compareProfitByAmount = (data) => {
  const previous = data[0]?.totalSales - data[0]?.totalExpense
  const current = data[1]?.totalSales - data[1]?.totalExpense


  if (previous === 0) return "No previous sales data"; // Avoid division by zero

  const percentage = ((current - previous) / previous) * 100;
  const retVal = {
    value: Math.abs(percentage).toFixed(0),
    increase: percentage > 0
  }
  return retVal
}

export const getPlainTextFromHtml = (html = "", wordLimit = 20) => {
  if (!html) return "";
  try {
    // Convert HTML → plain text
    const doc = new DOMParser().parseFromString(html, "text/html");
    const text = doc.body.textContent || "";

    // Limit to N words
    const words = text.trim().split(/\s+/);
    if (words.length <= wordLimit) return text.trim();

    return words.slice(0, wordLimit).join(" ") + "...";
  } catch {
    // Fallback regex stripping
    const text = html.replace(/<[^>]*>/g, "");
    const words = text.trim().split(/\s+/);
    if (words.length <= wordLimit) return text.trim();

    return words.slice(0, wordLimit).join(" ") + "...";
  }
};

export const cropWords = (text = "", wordLimit = 20) => {
  const words = text.trim().split(/\s+/);
  if (words.length <= wordLimit) return text.trim();
  return words.slice(0, wordLimit).join(" ") + "...";
};



export const createSlug = (text) => {
  return text
    .toLowerCase()            // lowercase
    .trim()                   // remove extra spaces
    .replace(/[^a-z0-9\s-]/g, "") // remove special chars
    .replace(/\s+/g, "-");    // replace spaces with -
}
